import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { useTran, useUnsavedChanges } from "@/hooks";
import { UnsavedChangesDialog } from "@/components/common";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useManageUserPageData } from "../hooks";
import ManageUserForm from "./ManageUserForm";
import ManageUserFooter from "./ManageUserFooter";

const ManageUserCard = observer(() => {
  const { t } = useTran();
  const { userId } = useParams();
  const { displayLabel, loading, errorMessage, hasChanges } =
    useManageUserPageData({
      userId,
    });
  const { showDialog, confirmDiscard, cancelDiscard } =
    useUnsavedChanges(hasChanges);

  const showFooter = Boolean(userId && !loading && !errorMessage);

  return (
    <Card className="flex h-full min-h-0 flex-col overflow-hidden">
      <CardHeader className="shrink-0">
        <CardTitle>{t("Manage User")}</CardTitle>

        <CardDescription>
          {displayLabel
            ? t("Update settings for {{user}}", { user: displayLabel })
            : t("Update user details, status, and access.")}
        </CardDescription>
      </CardHeader>

      <CardContent className="min-h-0 flex-1 overflow-hidden px-4 pb-4 pt-0 sm:px-6">
        <ManageUserForm />
      </CardContent>

      {showFooter ? (
        <div className="shrink-0">
          <ManageUserFooter />
        </div>
      ) : null}
      <UnsavedChangesDialog
        open={showDialog}
        onConfirm={confirmDiscard}
        onCancel={cancelDiscard}
      />
    </Card>
  );
});

export default ManageUserCard;
